import { render } from "./DetailDocumentItem.vue?vue&type=template&id=2d0aaff4"
import script from "./DetailDocumentItem.vue?vue&type=script&lang=js"
export * from "./DetailDocumentItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__